<template>
  <v-container fluid fill-height pa-0 ma-0>
    <!--  <v-app-bar app elevation="0" color="transparent" clipped-right clipped-left>
      <v-spacer></v-spacer>

      <language></language>
    </v-app-bar> -->

    <!-- Sizes your content based upon application components -->
    <v-container style="height: 400px;">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="subtitle-1 text-center" cols="12">
          <img src="@/assets/logo-white.svg" alt="avatar" width="240" />
        </v-col>
        <v-col cols="6" class="headline text-center">
          Por favor, espere mientras verificamos sus datos
        </v-col>
        <v-col class="subtitle-1 text-center" cols="7">
          Gracias por registrarse en PacReport, la plataforma de Inteligencia empresarial para Compras Públicas.
          Su cuenta ha sido creada con éxito, sin embargo, deberá esperar
          mientras verificamos su información de registro, le envieremos un mensaje en cuanto su acceso se encuentre habilitado. <br /><br />
          Su registro puede ser rechazado por alguna
          de las siguientes razones: <br /><br />a) Por proporcionar información de
          registro falsa o incorrecta. <br />b) Si su organización no cuenta con
          una suscripción anual o de prueba vigente. <br /><br />Para mayor
          información escríbanos a <strong>soporte@pac.report</strong>.
        </v-col>
        <v-col class="subtitle-1 text-center" cols="7">
          <v-btn color="secondary" @click="signOut">Volver</v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- <v-content pa-0 ma-0>

      <v-container pa-0 ma-0>
       
        <v-layout align-center justify-center>
          <img src="@/assets/logo-white.svg" alt="avatar" width="240" />

          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            rounded
            height="6"
            color="primary"
          ></v-progress-linear>
        </v-layout>
      </v-container>
    </v-content> -->

    <v-footer app color="transparent">
      <v-layout align-center justify-center>
        <span class="text-center body-2"
          >&reg; Inteldatos 2020 -
          {{ this.$Amplify.I18n.get("All rights reserved") }}</span
        >
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { AmplifyEventBus } from "aws-amplify-vue";
export default {
  name: "Verificacion",
  components: {},
  data() {
    return {};
  },
  methods: {
    ...mapActions(["setMisCpcs", "setEmpresa", "setSuscripcion"]),
    continuar: async function() {
      this.$router.push("/auth");
    },
    signOut: function() {
      this.$Amplify.Auth.signOut()
        .then(() => {
          this.logger.info("signout success");
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch((e) => this.setError(e));
    },
  },
  computed: {
    ...mapGetters(["empresa", "user"]),
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);

    /*  setTimeout(() => {
      this.loading = false;
      this.$router.push("/");
    }, 5000); */
  },
};
</script>
